import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import SpellcheckIcon from '@mui/icons-material/Spellcheck';
import { useTranslation } from 'react-i18next';
import { MapStateButton } from './MapStateButton';

export interface TrackMapToggleButtonProps {
  isMapped: boolean;
  isAutoMapped?: boolean;
  onClick: () => void;
}

export function TrackMapToggleButton({
  isMapped,
  isAutoMapped,
  onClick,
}: TrackMapToggleButtonProps) {
  const { t } = useTranslation();

  const tooltip = isMapped
    ? t('removeRequestMapping', 'Remove this track from selected request')
    : t('addRequestMapping', 'Assign this track to the selected request');

  return (
    <MapStateButton
      tooltip={tooltip}
      color={isMapped ? 'primary' : 'inherit'}
      filled={isMapped}
      onClick={onClick}
    >
      {isMapped ? (
        isAutoMapped ? (
          <SpellcheckIcon fontSize="small" />
        ) : (
          <CheckIcon fontSize="small" />
        )
      ) : (
        <AddIcon fontSize="small" />
      )}
    </MapStateButton>
  );
}
